module.exports = __webpack_public_path__ + "media/components/journeys/route-icons/car-23ff4b72f8e758aa5ab752f92d776b39.png";